module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_8023.34501db9.png";